import { useDealPortfolioStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import IDealPortfolio from "../interfaces/IDealPortfolio";

const useDealPortfolioUpdate = (): (portfolio: IDealPortfolio) => Promise<IDealPortfolio> => {
    const dealPortfolioStore = useDealPortfolioStore();

    return async (portfolio: IDealPortfolio): Promise<IDealPortfolio> => {
        try {
            const updated = await dealPortfolioStore.updatePortfolio(portfolio);
            showSuccessToast();
            return updated;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useDealPortfolioUpdate;
